import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/dashboard/listings/")({
  head: () => routeHead("/de/dashboard/listings/"),
  beforeLoad: () => {
    throw redirect({ href: "/de/my-listings-v2", statusCode: 301, replace: true });
  },
});
